import React, { useState } from 'react';
import ObliqueIcon from '@/components/icons/ObliqueIcon';
import SkeletonLoader from '@/components/ui/SkeletonLoader';

export default function TeamsSettings() {
    const [loading, setLoading] = useState(false);
    
    const mockTeamsData = [
        { id: 1, name: 'EX-PM', members: ['ND', 'DK', 'CS', 'GM'], extraCount: 5 },
        { id: 2, name: 'IC - PM', members: ['JS', 'SA', 'RV'], extraCount: 0 },
        { id: 3, name: 'IC - Sales', members: ['AK'], extraCount: 0 },
        { id: 4, name: 'Individual Contributors', members: ['RB', 'PE', 'MR'], extraCount: 13 },
        { id: 5, name: 'Team Aman - Sales', members: ['AK', 'NS', 'AB', 'RS', 'MS'], extraCount: 2 },
    ];

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '0 24px' }} className="animate-fade-in">
            {/* Banner */}
            <div style={{ 
                background: '#f0f9ff', 
                border: '1px solid #bae6fd', 
                borderRadius: '8px', 
                padding: '16px 20px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                marginTop: '24px',
                marginBottom: '24px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', flex: 1, paddingRight: '16px' }}>
                    <span style={{ fontSize: '14px', color: 'var(--text-primary)', lineHeight: '1.5' }}>
                        <strong>Use Teams to organize and manage users.</strong> Teams can help control access and visibility, and improve your reporting capabilities.
                        <span style={{ color: 'var(--blue)', cursor: 'pointer', textDecoration: 'underline', marginLeft: '4px' }}>Learn more about teams</span>
                    </span>
                </div>
                <button style={{ background: 'none', border: 'none', color: 'var(--text-tertiary)', cursor: 'pointer' }}>
                    <ObliqueIcon name="close" size={16} />
                </button>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: '6px', padding: '6px 12px', width: '280px' }}>
                    <ObliqueIcon name="search" size={16} color="var(--text-tertiary)" />
                    <input 
                        placeholder="Search" 
                        style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: '13px', color: 'var(--text-primary)', width: '100%' }}
                    />
                </div>
                <button style={{ background: 'var(--text-primary)', color: 'var(--bg-surface)', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                    Create team
                </button>
            </div>

            {/* Table */}
            <div style={{ flex: 1, overflow: 'auto', border: '1px solid var(--border)', borderRadius: '8px', background: 'var(--bg-surface)' }} className="custom-scrollbar">
                <div style={{ minWidth: 'max-content' }}>
                    <div style={{ display: 'flex', height: '48px', borderBottom: '1px solid var(--border)', background: 'var(--bg-page)', position: 'sticky', top: 0, zIndex: 10 }}>
                        <div style={{ width: '60px', flexShrink: 0, padding: '0 16px', display: 'flex', alignItems: 'center' }}>
                            <input type="checkbox" style={{ width: 'auto', cursor: 'pointer', margin: 0 }} />
                        </div>
                        <div style={{ width: '400px', flexShrink: 0, padding: '0 16px', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>Name ↑↓</div>
                        <div style={{ flex: 1, flexShrink: 0, padding: '0 16px', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>Team members ↑↓</div>
                    </div>

                    {loading ? (
                        <SkeletonLoader type="table" rows={5} />
                    ) : (
                        mockTeamsData.map((team, idx) => (
                            <div key={team.id} style={{ display: 'flex', minHeight: '64px', borderBottom: '1px solid var(--border)', alignItems: 'center', transition: 'background 0.15s' }} className="hover-bg-subtle group">
                                <div style={{ width: '60px', flexShrink: 0, padding: '0 16px', display: 'flex', alignItems: 'center' }}>
                                    <input type="checkbox" style={{ width: 'auto', cursor: 'pointer', margin: 0 }} />
                                </div>
                                <div style={{ width: '400px', flexShrink: 0, padding: '0 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span style={{ fontSize: '14px', fontWeight: '600', color: 'var(--blue)', cursor: 'pointer' }} className="hover-underline">{team.name}</span>
                                    <div className="row-actions" style={{ display: 'flex', gap: '8px' }}>
                                        <button style={{ padding: '4px 12px', background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>Edit</button>
                                        <button style={{ padding: '4px 12px', background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>Delete</button>
                                    </div>
                                </div>
                                <div style={{ flex: 1, flexShrink: 0, padding: '0 16px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
                                        {team.members.map((initial, i) => (
                                            <div key={i} style={{ 
                                                width: '28px', 
                                                height: '28px', 
                                                borderRadius: '50%', 
                                                background: 'var(--bg-muted)', 
                                                border: '2px solid var(--bg-surface)', 
                                                color: 'var(--text-secondary)', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center', 
                                                fontSize: '11px', 
                                                fontWeight: '600', 
                                                marginLeft: i > 0 ? '-8px' : 0,
                                                position: 'relative',
                                                zIndex: team.members.length - i
                                            }}>
                                                {initial}
                                            </div>
                                        ))}
                                    </div>
                                    {team.extraCount > 0 && (
                                        <span style={{ fontSize: '13px', color: 'var(--text-secondary)', marginLeft: '8px', fontWeight: '500' }}>+{team.extraCount}</span>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <style>{`
                .group .row-actions { opacity: 0; transition: opacity 0.15s; }
                .group:hover .row-actions { opacity: 1; }
            `}</style>
        </div>
    );
}
